import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Empty, Form, Space, Tooltip } from 'antd'
import { debounce } from 'lodash'
import get from 'lodash.get'
import React, { useMemo, useState } from 'react'
import {
  convertPriceToNumber,
  hasPermission,
  removeNullUndefined
} from '../../config-func'
import { PAGE_SIZE_OPTIONS } from '../../configData'
import {
  postAdd,
  postCommunityDetail,
  postDelete,
  postSearch,
  postUpdate
} from '../../services/postservice'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import TableField from '../common/Table/TableField'
import FilterForm from './FilterForm'
import FormAddExcel from './FormAddExcel'
import FormPost from './FormPost'
import { imessAdd, imessDelete, imessDetail, imessSearch, imessUpdate } from '../../services/imessService'
import dayjs from 'dayjs'
// const { TextArea } = Input
import Loading from '../Loading';

// const { Option } = Select
export const ACTION_MODE = {
  VIEW: 'VIEW',
  ADD: 'ADD',
  UPDATE: 'UPDATE'
}
// const { TabPane } = Tabs

const ImessManagement = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [form] = Form.useForm()
  const [formSearch] = Form.useForm()
  const [data, setData] = useState([])
  // Form thêm mới
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({
    current: 1, // Trang hiện tại
    pageSize: 10 // Số bản ghi mỗi trang
  })

  const [isModalImportOpen, setIsModalImportOpen] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      width: 60,
      render: (_, __, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1
    },
    {
      title: 'Họ tên',
      dataIndex: 'name',
      key: 'name',
      width: 150,
      // render: (_, __, index) => (page - 1) * pageSize + index + 1
    },
    {
      title: 'Message',
      dataIndex: 'message',
      key: 'message',
      width: 300,
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'phone_number',
      key: 'phone_number',
      width: 150,
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'status',
      width: 150,
    },
    {
      title: 'Kênh gửi',
      dataIndex: 'task_type',
      key: 'task_type',
      width: 150,
    },
    {
      title: 'Thiết bị gửi',
      dataIndex: 'deviceCode',
      key: 'deviceCode',
      width: 150,
    },

    {
      title: 'Dự án',
      dataIndex: 'project',
      key: 'project',
      width: 150,
      // render: (_, record) => (
      //   <span>
      //     {ProductType.find((n) => n.value === record.post_type)?.label || ''}
      //   </span>
      // )
    },
    {
      title: 'Số Phòng/Đc',
      dataIndex: 'room_number',
      key: 'room_number',
      width: 150,
    },
    {
      title: 'Số lần gửi',
      dataIndex: 'number_of_send',
      key: 'number_of_send',
      width: 150,
    },
    {
      title: 'Ngày cập nhật',
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: 150,
      render: (_, record) => {
        return <span>{record?.updated_at ? dayjs(record?.updated_at).format('HH:mm:ss DD/MM/YYYY') : ''}</span>
      }
    },

    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      width: 150,
      render: (_, record) => {
        return (
          <Space size="small">
            {/* <Tooltip title="Chỉnh sửa">
              <EditOutlined
                onClick={() => {
                  setMode(ACTION_MODE.UPDATE)
                  getDetailImess(record.id)
                }}
                style={{ fontSize: '16px', color: '#08c', cursor: 'pointer' }}
              />
            </Tooltip> */}
            {hasPermission('P60.2', permissions) && (
              <Tooltip title="Chỉnh sửa">
                <Button
                  style={{ width: 32 }}
                  icon={<EditOutlined />}
                  onClick={() => {
                    setMode(ACTION_MODE.UPDATE)
                    getDetailImess(record.id)
                  }}
                />
              </Tooltip>
            )}
            {/* {hasPermission('P39.4', permissions) && (
              <Tooltip title="Lịch sử">
                <Button
                  // style={{ width: 32 }}
                  icon={<HistoryOutlined />}
                  onClick={() => {
                    getListHistory(record.id)
                  }}
                >
                  
                 Xem lịch sử  
                </Button>
              </Tooltip>
            )} */}

            {record.status !== 'inactive' &&
              hasPermission('P60.5', permissions) && (
                <Tooltip title="Xóa">
                  <Button
                    style={{ width: 32 }}
                    icon={<DeleteOutlined style={{ color: 'red' }} />}
                    onClick={() =>
                      showConfirm({
                        title: 'Xác nhận xoá',
                        content: (
                          <div>
                            Bạn có chắc chắn muốn xoá imess
                            <b> {record.name}</b> không?
                          </div>
                        ),
                        onOk: () => deleteImess([record.id])
                      })
                    }
                  />
                </Tooltip>
              )}
            {/* <Button type="primary">Chi tiết</Button>
            <Button danger>Xóa</Button> */}
          </Space>
        )
      }
    }
  ]
  // Lấy danh sách post
  const fetchData = async (values = {}) => {
    setLoading(true)

    const value = removeNullUndefined(values)
    try {
      const body = { ...value }
      const res = await imessSearch(body)

      setData(res)
      // setPagination((prev) => ({
      //   ...prev
      // }))
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  useMemo(() => {
    if (pagination.current && pagination.pageSize) {
      const value = formSearch.getFieldsValue()
      fetchData({
        ...value,
        current: pagination.current,
        pageSize: pagination.pageSize
      })
    }
  }, [pagination.current, pagination.pageSize])

  // Khi thay đổi trang
  const handlePageChange = (current, pageSize) => {
    setPagination((prev) => ({
      ...prev,
      current: prev.pageSize !== pageSize ? 1 : current, // Nếu đổi pageSize thì reset current
      pageSize
    }))
  }

  const handleSearch = debounce((values) => {
    console.log('Tìm kiếm với:', values)
  }, 300)

  const handleSave = async () => {
    setLoading(true)
    try {
      const values = await form.validateFields()

      const { id, ...data } = values
      let body = {}
      body = {
        ...data
      }

      const res =
        mode == ACTION_MODE.ADD
          ? await imessAdd(body)
          : await imessUpdate(body, id)

      openNotification(
        'success',
        mode == ACTION_MODE.ADD
          ? 'Tạo imess thành công'
          : 'Cập nhật imess thành công'
      )
      fetchData()
      form.resetFields()
      setIsModalOpen(false)
    } catch (err) {
      // Lấy danh sách lỗi từ API
      const errors = get(err, 'response.data.message', [])

      // Xử lý lỗi nếu là mảng
      const errorMessages = Array.isArray(errors)
        ? errors.map((error) => error.message).join('\n')
        : errors // Nếu không phải mảng, lấy trực tiếp

      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  // Xóa tin
  const deleteImess = async (ids) => {
    setLoading(true)
    try {
      // Lọc ra các key có giá trị true và đưa vào mảng
      const body = {
        ids,
        // from: 3,
        // type: 15,
        // department_id: deId
      }
      const res = await imessDelete(body)
      if(res.success) {
        fetchData()
        setSelectedRowKeys([])
        openNotification('success', 'Xóa imess thành công')
      } else {
        openNotification('error', 'Đã có lỗi xảy ra')
      }
      
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }
  // Chi tiết quyền
  const getDetailImess = async (id) => {
    setLoading(true)
    try {
      const res = await imessDetail(id) // Assuming roleSearch is an API function

      if (res && res.id) {
        setIsModalOpen(true)
        const values = res
        form.setFieldsValue({
          ...values
        })
      } else {
        openNotification('error', 'Không tìm thấy dữ liệu')
      }
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }



  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        <FilterForm
          form={formSearch}
          pagination={pagination}
          setPagination={setPagination}
          fetchData={fetchData}
        />
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {/* <h2 className="text-2xl font-semibold my-2">Quản lý tin BĐS nội bộ</h2> */}
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
            {hasPermission('P60.3', permissions) && (
              <Button
                type="primary"
                key="primary"
                onClick={() => {
                  setIsModalImportOpen(true)
                }}
              >
                <PlusOutlined /> Import Excel
              </Button>
            )}

            {hasPermission('P60.1', permissions) && (
              <Button
                type="primary"
                // htmlType="submit"
                onClick={() => {
                  setIsModalOpen(true)
                  setMode(ACTION_MODE.ADD)
                }}
              >
                <PlusOutlined />
                Thêm mới
              </Button>
            )}
            {hasPermission('P60.3', permissions) && (
              <Button
                danger
                // disabled={selectedRowKeys.length > 0 ? false : true}
                type="primary"
                onClick={() => {
                  if (selectedRowKeys.length == 0) {
                    openNotification('error', 'Vui lòng chọn bản ghi')
                  } else {
                    showConfirm({
                      title: 'Xác nhận xoá',
                      content: (
                        <div>
                          Bạn có chắc chắn muốn xoá{' '}
                          <b>{selectedRowKeys?.length}</b> tin không?
                        </div>
                      ),
                      onOk: () => deleteImess(selectedRowKeys)
                    })
                  }
                }}
              >
                <DeleteOutlined />
                Xoá
              </Button>
            )}
          </div>
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          data={data?.data}
          scroll={{ x: data?.data?.length > 0 ? 'max-content' : '100%', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onChange: handlePageChange,
            showTotal: (total, range) =>
              `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`
          }}
          rowKey="id"
          locale={{
            emptyText: <Empty description="Không có dữ liệu" />, // Hiển thị "Không có dữ liệu" khi bảng không có dữ liệu
            triggerDesc: 'Sắp xếp giảm dần', // Khi click vào cột để sort giảm dần
            triggerAsc: 'Sắp xếp tăng dần', // Khi click vào cột để sort tăng dần
            cancelSort: 'Hủy sắp xếp' // Khi bỏ sắp xếp
          }}
          rowSelection={{
            selectedRowKeys: selectedRowKeys, // Mảng chứa các row được chọn
            onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys), // Xử lý khi chọn row
            type: 'checkbox', // Hoặc 'radio' nếu chỉ chọn được 1
            preserveSelectedRowKeys: true // Giữ selection khi phân trang
          }}
        />
      </Card>
      {/* Modal Thêm mới sản phẩm */}
      <ModalCustom
        title={
          mode == ACTION_MODE.UPDATE
            ? 'Chỉnh sửa imess'
            : 'Thêm mới imess'
        }
        visible={isModalOpen}
        centered
        width={600}
        // className="modal-bond"
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            console.log('Validation failed:', error)
            if (error?.errorFields?.length > 0) {
              form.scrollToField(error.errorFields[0].name, {
                behavior: 'smooth',
                block: 'center' // Đảm bảo label không bị che
              })
            }
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
      >
        <FormPost form={form} handleSearch={handleSearch} />
      </ModalCustom>
      <FormAddExcel
        isModalOpen={isModalImportOpen}
        setIsModalOpen={setIsModalImportOpen}
        fetchData={fetchData}
      />  
      <ModalConfirm />
    </div>
  )
}

export default ImessManagement
